module.exports = __webpack_public_path__ + "static/img/3.e7e5984.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/3.png
// module id = 7uPT
// module chunks = 0